// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarCustomFilterButton.tsx
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Badge, Dialog, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { identity, pickBy } from "lodash";
import { ReactNode } from "react";
import { useLongPress } from "../../../modules/helpers";
import { useFilter } from "../../List";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";
export type RenderButtonProps = {
  longPressEvent: any;
  filterModal: any;
  buttonSize: any;
  tooltipText: any;
};
export interface DataGridToolbarCustomFilterButtonProps
  extends DataGridToolbarProps {
  icon?: ReactNode;
  tooltipText?: string;
  renderButton?: (props: RenderButtonProps) => JSX.Element;
  optionParams?: (filter: any) => any;
}

export default function DataGridToolbarCustomFilterButton({
  clearSearch,
  onChange,
  onCreate,
  load,
  value,
  apiRef,
  editUrl,
  canCreate,
  canBatchActions,
  canHandleTrash,
  deleteSelectedItems,
  restoreSelectedItems,
  headerItems = [],
  selectionState,
  trashType,
  setTrashType,
  extraHeaderItem,
  rowsState,
  buttonSize,
  loadOptions,
  renderFilter,
  applyFilter,
  resetFilter,
  optionComponent,
  filter,
  attributesNotCount,
  icon,
  tooltipText,
  renderButton,
  optionParams,
}: DataGridToolbarCustomFilterButtonProps) {
  const filterModal = useFilter<any, any>({
    optionParams,
    attributesNotCount,
    filter: { ...filter, ...(value && value !== "" ? { keyword: value } : {}) },
    loadOptions: loadOptions
      ? () =>
          loadOptions(
            {
              cache: {
                ignoreCache: false,
              },
              params: optionParams ? optionParams(filter) : undefined,
            } as any,
            optionComponent
          )
      : undefined,
  });

  const longPressEvent = useLongPress(
    () => {
      if (filterModal.filterCount > 0) {
        resetFilter && resetFilter();
      }
    },
    () => {
      filterModal.setShowFilter(true);
    }
  );
  return (
    <>
      <DataGridToolbarButtonContainer>
        {renderButton ? (
          renderButton({ longPressEvent, filterModal, buttonSize, tooltipText })
        ) : (
          <Tooltip
            title={
              tooltipText
                ? tooltipText
                : `${I18n.t("App.filter")} (${I18n.t("App.longPressToClear")})`
            }
            color="info"
          >
            <IconButton
              color={filterModal.filterCount > 0 ? "primary" : undefined}
              {...longPressEvent}
            >
              <Badge badgeContent={filterModal.filterCount} color="primary">
                {!!icon ? icon : <FilterAltIcon fontSize={buttonSize} />}
              </Badge>
            </IconButton>
          </Tooltip>
        )}
      </DataGridToolbarButtonContainer>
      {!!renderFilter && (
        <Dialog
          open={filterModal.showFilter}
          onClose={() => filterModal.setShowFilter(false)}
        >
          {renderFilter({
            ...filterModal,
            applyFilter: (item: any) =>
              applyFilter && applyFilter(pickBy(item, identity)),
            resetFilter: () => resetFilter && resetFilter(),
          })}
        </Dialog>
      )}
    </>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarCustomFilterButton.tsx
